import { Link } from 'react-router-dom';

const Logo = () => {
    return (
        <Link
            to="/"
            className="d-flex align-items-center text-decoration-none w-100"
            style={{ gap: '12px' }}
        >
            <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    background: 'rgba(var(--pc-sidebar-color-rgb), 0.08)',
                    border: '1px solid rgba(var(--pc-sidebar-color-rgb), 0.15)'
                }}
            >
                <img src="/logo.svg" alt="eContractor logo" style={{ width: '28px', height: '28px' }} />
            </div>

            <div className="d-flex flex-column lh-sm">
                <span
                    style={{
                        color: 'var(--pc-sidebar-color)',
                        fontSize: '20px',
                        fontWeight: 700,
                        letterSpacing: '0.2px'
                    }}
                >
                    eContractor
                </span>
                <span
                    style={{
                        color: '#4d74b9',
                        fontSize: '11px',
                        fontWeight: 600,
                        letterSpacing: '1.4px'
                    }}
                >
                    CRM <span style={{ color: '#f49c06' }}>•</span> ERP
                </span>
            </div>
        </Link>
    );
};

export default Logo;